import React, { useContext, useState, useEffect } from 'react';
import Scrollbar from 'react-custom-scrollbars';
import { AppContext, CARDS_PAGE_PATH } from '../../App';
import { getUnique } from "../../core/helpers";
import Wrapper from "../../components/Wrapper/Wrapper";
import PageHeader from "../../components/PageHeader/PageHeader";
import PageFooter from "../../components/PageFooter/PageFooter";
import Cards from "../../components/Cards/Cards";
import Toggle from "../../components/Toggle/Toggle";
import CardsTiles from "../../components/CardsTiles/CardsTiles";
import BackIcon from '../../icons/back.svg';
import './CardsPage.styles.scss';
import GlowingBubbles from "../../components/GlowingBubbles/GlowingBubbles";
import {
    getCategoryId,
    getCategoryPath,
    getCategoryPermissionLevel,
    PERMISSION_LEVEL_ENUM,
    sortMicroDrivers
} from "../../App.helpers";

function CardsPage({ match }) {
    const {
        data,
        credentials,
        setIsLoginModalActive,
        setIsSubscribersPopupOpened,
        setIsCardsPageBeenShown,
    } = useContext(AppContext);
    const [driversTabIndex, setDriversTabIndex] = useState(0);
    const [driversCategoryId, setDriversCategoryId] = useState('');
    const categoryId = getCategoryId(match.params.name);

    useEffect(() => {
        setDriversCategoryId('');
    }, [driversTabIndex]);

    useEffect(() => {
        setIsCardsPageBeenShown(true);
    }, []);

    const mapData = (card, categoryId) => {
        const result = {
            ...card,
            img: `${process.env.REACT_APP_BASE_ROUTE}thumb-list/${card.id}.jpeg`,
        };

        let hasPermission = true;
        hasPermission = hasPermission && getCategoryPermissionLevel(categoryId) <= credentials.permissionLevel;

        if (hasPermission) {
            result.link = `${CARDS_PAGE_PATH}/${getCategoryPath(categoryId)}/${card.id}`;
        } else if (credentials.permissionLevel === PERMISSION_LEVEL_ENUM.GUEST) {
            result.onClick = setIsLoginModalActive;
        } else {
            result.onClick = () => setIsSubscribersPopupOpened(true);
        }

        return result;
    };

    const segments = data.segments.map((card) => mapData(card, 1));
    const occasions = data.occasions.map((card) => mapData(card, 2));
    const triggers = data.triggers.map((card) => mapData(card, 3));
    const allDrivers = data.drivers.map((card) => mapData(card, 4));


    if (Object.keys(data).length === 0) return;

    let drivers = [];
    let driversTiles = [];

    if (driversTabIndex === 0) {
        drivers = allDrivers.filter((driver) => !driver.type);
    } else {
        const microDrivers = allDrivers.filter((driver) => driver.type);
        if (driversCategoryId === '') {
            driversTiles = getUnique(microDrivers.map(({ header }) => header)).sort(sortMicroDrivers);
            driversTiles = driversTiles.map(name => ({
                name,
                count: microDrivers.filter(({ header }) => header === name).length,
            }))
        } else {
            drivers = microDrivers.filter(({ header }) => header === driversCategoryId);
        }
    }

    return (
        <>
            <PageHeader />
            <div className="cards-page">
                <Scrollbar
                    renderThumbVertical={(props) => (
                        <div className="scrollbar__thumb"/>
                    )}
                >
                    <div className="cards-page__content">
                        <GlowingBubbles/>
                        <Wrapper>

                            {categoryId === 1 && (
                                <>
                                    <div className="cards-page__top">
                                        <div className="cards-page__left">
                                            <div className="cards-page__text">
                                                Triggers, occasions, and needs culminate in a food <span>DECISION</span>.
                                                Where consumers get their food – such as the foodservice segment – is a
                                                vital
                                                part of that decision.
                                            </div>
                                            <div className="cards-page__text">
                                                View details for any segment by selecting it below.
                                            </div>
                                        </div>
                                    </div>
                                    <Cards data={segments}/>
                                </>
                            )}
                            {categoryId === 2 && (
                                <>
                                    <div className="cards-page__top">
                                        <div className="cards-page__left">
                                            <div className="cards-page__text">
                                                <span>OCCASIONS</span> are the situations consumers face when making their eating
                                                decision.
                                            </div>
                                            <div className="cards-page__text">
                                                View details for any occasion by selecting it below.
                                            </div>
                                        </div>
                                    </div>
                                    <Cards data={occasions}/>
                                </>
                            )}
                            {categoryId === 3 && (
                                <>
                                    <div className="cards-page__top">
                                        <div className="cards-page__left">
                                            <div className="cards-page__text">
                                                <span>TRIGGERS</span> are the impulse that activate the consumer decision to eat.
                                            </div>
                                            <div className="cards-page__text">
                                                View details for any trigger by selecting it below.
                                            </div>
                                        </div>
                                    </div>
                                    <Cards data={triggers}/>
                                </>
                            )}
                            {categoryId === 4 && (
                                <>
                                    <div className="cards-page__top">
                                        <div className="cards-page__left">
                                            <div className="cards-page__text">
                                                <span>NEEDS</span> describe the range of motivations consumers consider when forming
                                                their
                                                decision. While their ultimate choice won’t always satisfy each need, it’s
                                                always helpful to know what’s on their mind.
                                            </div>
                                            <div className="cards-page__text">
                                                View details for any need by selecting it below.
                                            </div>
                                        </div>
                                        <Toggle
                                            items={['Mega drivers', 'Micro drivers']}
                                            activeItemIndex={driversTabIndex}
                                            setActiveItemIndex={setDriversTabIndex}
                                        />
                                        <button
                                            className={`
                                            cards-page__drivers-back-btn
                                            ${driversCategoryId === '' ? 'cards-page__drivers-back-btn--hidden' : ''}
                                        `}
                                            onClick={() => setDriversCategoryId('')}
                                        >
                                            <BackIcon/>
                                            Back
                                        </button>
                                    </div>
                                    {driversTiles.length > 0 && (
                                        <CardsTiles
                                            items={driversTiles}
                                            handleItemClick={setDriversCategoryId}
                                        />
                                    )}
                                    {drivers.length > 0 && <Cards data={drivers}/>}
                                </>
                            )}
                        </Wrapper>
                    </div>
                </Scrollbar>
            </div>
            <PageFooter />
        </>
    );
}

export default CardsPage;